import slidesContent from './data/slides.json'
import sidebarContent from './data/sidebar.json'

import BrandSlide from './slides/BrandSlide.vue'
import ContactDetailsSalesSlide from './slides/ContactDetailsSalesSlide.vue'
import ContactDetailsSupportSlide from './slides/ContactDetailsSupportSlide.vue'
import FeaturesOfInterestSlide from './slides/FeaturesOfInterestSlide.vue'
import FleetSizeSlide from './slides/FleetSizeSlide.vue'
import MessageSlide from './slides/MessageSlide.vue'
import NetworkProvidersSlide from './slides/NetworkProvidersSlide.vue'
import NumDevicesSlide from './slides/NumDevicesSlide.vue'
import ProductsOfInterestSlide from './slides/ProductsOfInterestSlide.vue'
import ProspectDetailsSalesSlide from './slides/ProspectDetailsSalesSlide.vue'
import ProspectDetailsSupportSlide from './slides/ProspectDetailsSupportSlide.vue'
import RequestTypeSlide from './slides/RequestTypeSlide.vue'

// This array determines the order that the slides appear in, when they are enabled, and which
// components and content they use.
//
// Fields:
//   key: A unique name for the slide.
//   when: Only include the slide in the wizard form when this function returns true.
//   component: The component used to render the slide.
//   content: The locale-specific text for the slide.
//   sidebarContent (optional): Content for the blue-background sidebar, if needed.
//
export default [
  {
    key: 'brand',
    when: (formOptions) => formOptions.chooseBrand,
    component: BrandSlide,
    content: slidesContent.brand,
  },
  {
    key: 'requestType',
    when: (formOptions) => formOptions.chooseRequestType,
    component: RequestTypeSlide,
    content: slidesContent.requestType,
    sidebarContent: sidebarContent.requestType,
  },
  {
    key: 'productsOfInterest',
    when: (formOptions) => (
      formOptions.brand === 'inseego'
      && formOptions.requestType === 'sales'
      && !formOptions.shortForm
    ),
    component: ProductsOfInterestSlide,
    content: slidesContent.productsOfInterest,
    sidebarContent: sidebarContent.productsOfInterest,
  },
  {
    key: 'numDevices',
    when: (formOptions) => (
      formOptions.brand === 'inseego'
      && formOptions.requestType === 'sales'
    ),
    component: NumDevicesSlide,
    content: slidesContent.numDevices,
    sidebarContent: sidebarContent.numDevices,
  },
  {
    key: 'personalUseMessage',
    when: (formOptions) => (
      formOptions.brand === 'inseego'
      && formOptions.requestType === 'sales'
      && formOptions.oneDeviceOnly === true
    ),
    component: MessageSlide,
    content: slidesContent.personalUseMessage,
  },
  {
    key: 'networkProviders',
    when: (formOptions) => (
      formOptions.brand === 'inseego'
      && formOptions.requestType === 'sales'
    ),
    component: NetworkProvidersSlide,
    content: slidesContent.networkProviders,
    sidebarContent: sidebarContent.networkProvider,
  },
  {
    key: 'featuresOfInterest',
    when: (formOptions) => (
      formOptions.brand === 'inseegoFleet'
      && formOptions.requestType === 'sales'
      && !formOptions.shortForm
    ),
    component: FeaturesOfInterestSlide,
    content: slidesContent.featuresOfInterest,
  },
  {
    key: 'prospectDetailsSales',
    when: (formOptions) => formOptions.requestType === 'sales',
    component: ProspectDetailsSalesSlide,
    content: slidesContent.prospectDetails,
    sidebarContent: (formOptions) => (
      formOptions.brand === 'inseego' ? sidebarContent.prospectDetailsSales5g : null
    ),
  },
  {
    key: 'prospectDetailsSupport',
    when: (formOptions) => formOptions.requestType === 'support',
    component: ProspectDetailsSupportSlide,
    content: slidesContent.prospectDetails,
  },
  {
    key: 'fleetSize',
    when: (formOptions) => (
      formOptions.brand === 'inseegoFleet'
      && formOptions.requestType === 'sales'
      && !formOptions.shortForm
    ),
    component: FleetSizeSlide,
    content: slidesContent.fleetSize,
  },
  {
    key: 'contactDetailsSales',
    when: (formOptions) => formOptions.requestType === 'sales',
    component: ContactDetailsSalesSlide,
    content: slidesContent.contactDetailsSales,
    sidebarContent: sidebarContent.contactDetailsSales,
  },
  {
    key: 'contactDetailsSupport',
    when: (formOptions) => formOptions.requestType === 'support',
    component: ContactDetailsSupportSlide,
    content: slidesContent.contactDetailsSupport,
  },
]
